import { useState } from "react";
import { CatalogAPI } from "../../providers/CatalogAPI";
import { Drawer } from "../../shared/components/Drawer";
import { Button } from "../../shared/components/Button";
import { Empty } from "@components";
import { Icon } from "shared/components/core/Icon";

export const SKUDrawer = ({ visible, service, onSave, onClose }) => {
    const [loading, setLoading] = useState(false);

    const selectFileHandler = async () => {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = ".csv";

        input.onchange = e => {
            const file = e.target.files[0];

            // setting up the reader
            const reader = new FileReader();
            reader.readAsText(file, 'UTF-8');
            reader.onload = async (reader_event) => {
                const content = reader_event.target.result;

                const confirmed = await window.confirm({
                    text: "Você tem certeza que deseja aplicar esse arquivo?",
                    confirmText: "Sim",
                    cancelText: "Cancelar",
                });

                if (!confirmed) {
                    return false;
                }

                // Realizar o upload do arquivo
                setLoading(true);
                const response = await CatalogAPI.postImportSKU(service, content);
                setLoading(false);

                if (response.getErrors([]).length > 0) {
                    alert({ text: response.getErrors()[0], buttonText: "Ok" });
                } else {
                    alert({ text: "SKUs e Preços importados com sucesso", buttonText: "Ok" });
                    onSave();
                }
            }
        }

        input.click();
    }

    const downloadCatalogHandler = async () => {
        await CatalogAPI.getDownloadSKU(service);
    }

    return (
        <Drawer
            visible={visible}
            onClose={() => onClose()}
            title="Importar/Exportar SKU e Preços"
            footer={
                <div class="d-flex flex-column w-100">
                    <Button
                        design="two"
                        className="w-100 mb-10"
                        disabled={loading}
                        loading={loading}
                        onClick={downloadCatalogHandler}
                    >
                        Baixar SKUS e Preços
                    </Button>
                    <Button
                        design="primary"
                        className="w-100 mb-10"
                        disabled={loading}
                        loading={loading}
                        onClick={selectFileHandler}
                    >
                        Importar SKUS e Preços
                    </Button>
                </div>
            }
            withoutTransition
        >
            <Empty>
                <Icon name="exclamation-circle" size="4x" light />
                <p>Atenção</p>
                <span>
                    <ol style={{ textAlign: 'left' }}>
                        <li class={"mb-10"}>Baixe o arquivo do cardápio através do botão "Baixar SKUs e Preços".</li>
                        <li class={"mb-10"}>Preencha o arquivo CSV baixado com os SKUS e Preços dos respectivos produtos e opções.</li>
                        <li class={"mb-10"}>Importe o arquivo CSV editado utilizando o botão "Importar SKUS e Preços".</li>
                    </ol>
                </span>
            </Empty>
        </Drawer>
    );
}